import { observer } from "mobx-react-lite";
import React from "react";
import { TailwindModal } from "../components";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { useStore } from "../helpers";
import { useTranslation } from "react-i18next";

export const MultipleFaceDetect = observer((props: any) => {
  const { aiGentoolStore } = useStore();
  const { multiple_faces_detected } = aiGentoolStore;
  const {t} = useTranslation("fetchFromFacialRecognition")

  const handleScanAgain = () => {
    aiGentoolStore.show_multiple_faces_detected(false);
    aiGentoolStore.toggle_image_capture_modal(true);
  };

  return (
    <>
      <div>
        <TailwindModal isOpen={multiple_faces_detected}>
          <div className="bg-common-white rounded-2xl p-4 max-w-4xl w-full mx-auto h-[85vh] flex flex-col items-center justify-center">
            <DotLottieReact
              src="https://lottie.host/677e1e16-ff85-4df2-b2d1-df290d599952/8ZCNP9e9Gq.lottie"
              loop
              autoplay
              className={"opacity-75 w-85 h-60"}
            />

            <p className="text-gray-400 text-base font-semibold text-center mb-4 ">
              {t("multiple_faces_detected")}
              <br />
              {t("face_clearly")}
            </p>

            <p
              onClick={handleScanAgain}
              className="text-[#7c3aed] underline cursor-pointer hover:text-[#6d28d9] mt-4"
            >
              {t("scan_again")}
            </p>
          </div>
        </TailwindModal>
      </div>
    </>
  );
});
